import * as React from "react";
import type { SVGProps } from "react";
const SvgBulgariaAir = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <linearGradient
      id="bulgaria-air_svg__b"
      x1={38.514}
      x2={3.712}
      y1={30.427}
      y2={15.855}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0} stopColor="#e5e5e5" />
      <stop offset={0.119} stopColor="#eee" />
      <stop offset={0.264} stopColor="#fff" />
      <stop offset={0.455} stopColor="#fbfbfb" />
      <stop offset={0.635} stopColor="#f0f0f0" />
      <stop offset={0.81} stopColor="#ddd" />
      <stop offset={0.981} stopColor="#c2c2c2" />
      <stop offset={1} stopColor="#bfbfbf" />
    </linearGradient>
    <linearGradient
      id="bulgaria-air_svg__d"
      x1={18.988}
      x2={25.154}
      y1={11.509}
      y2={41.029}
      gradientUnits="userSpaceOnUse"
    >
      <stop offset={0.093} stopColor="#7fbb85" />
      <stop offset={0.167} stopColor="#73b874" />
      <stop offset={0.338} stopColor="#5aaf53" />
      <stop offset={0.486} stopColor="#45a73d" />
      <stop offset={0.604} stopColor="#38a231" />
      <stop offset={0.676} stopColor="#33a02c" />
      <stop offset={0.885} stopColor="#00742f" />
    </linearGradient>
    <linearGradient id="bulgaria-air_svg__a">
      <stop offset={0.066} stopColor="#e36853" />
      <stop offset={0.352} stopColor="red" />
      <stop offset={0.533} stopColor="#fd0002" />
      <stop offset={0.628} stopColor="#f40006" />
      <stop offset={0.702} stopColor="#e70009" />
      <stop offset={0.766} stopColor="#d3000c" />
      <stop offset={0.823} stopColor="#ba0010" />
      <stop offset={0.85} stopColor="#ab0012" />
    </linearGradient>
    <linearGradient
      xlinkHref="#bulgaria-air_svg__a"
      id="bulgaria-air_svg__e"
      x1={24.81}
      x2={24.862}
      y1={20.59}
      y2={38.545}
      gradientUnits="userSpaceOnUse"
    />
    <linearGradient
      xlinkHref="#bulgaria-air_svg__a"
      id="bulgaria-air_svg__f"
      x1={38.803}
      x2={46.507}
      y1={45.872}
      y2={32.703}
      gradientUnits="userSpaceOnUse"
    />
    <path
      fill="url(#bulgaria-air_svg__b)"
      d="M48.507 31.893c-1.611-4.263-5.612-7.419-11.557-10.132C22.836 15.284 2.945 10.191 1 1c1 16.498 23.726 18.879 36.95 25.08 3.223 1.55 6 3.986 7.612 5.647 2.612 2.657 1.334 9.024-1.445 11.681 5.668-4.097 5.223-9.3 4.39-11.515"
    />
    <path
      fill="url(#bulgaria-air_svg__d)"
      d="M43.284 28.792c-9.946-6.92-35.45-11.681-38.061-16 5.167 13.177 29.504 12.513 38.394 20.65 6.724 6.146-.722 10.908-2.5 12.015 6.39-3.488 10.446-10.907 2.167-16.665"
    />
    <path
      fill="url(#bulgaria-air_svg__e)"
      d="M46.729 37.872c-.333-10.408-30.616-12.567-37.394-18.104C17.39 32.945 44.006 32.17 45.84 39.09c.389 1.495-.5 2.934-1.611 3.986 1.5-1.495 2.555-2.768 2.5-5.204"
    />
    <path
      fill="url(#bulgaria-air_svg__f)"
      d="M32.894 49c9.168-3.045 13.446-10.464 8.223-12.9 9.78 2.99 2.778 9.634-8.223 12.9"
    />
  </svg>
);
export default SvgBulgariaAir;
